<mat-dialog-content role="main">

    <!-- Header -->
    <h3 class="warningText" translate>
        WARNING
    </h3>

    <!-- Body -->
    <div class="warningText" translate>
        Changes have been entered but not saved.
    </div>
    <div style="padding: 5px; margin-bottom: 15px; text-align: center;">
        If you continue without saving, the changes will be lost.
    </div>
    <div *ngIf="errors.length > 0" style="text-align: center; margin-bottom: 15px;" class="warningText">
        <b>Due to errors, saving is not possible.</b><br/>
        Either Continue without Saving <br/>
        or select Cancel and correct the errors.
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky; height: unset;">
    <tyl-button *ngIf="errors.length == 0 && !preventSave" image="save black.png" label="Save and Continue" (clickEvent)="leavePage(1)"></tyl-button>
    <tyl-button *ngIf="errors.length > 0 || preventSave" image="save disabled.png" label="Save and Continue" textColor="lightgrey" [disabled]="true"></tyl-button>
    <tyl-button image="next arrow.png" label="Continue without Saving" (clickEvent)="leavePage(0)"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="leavePage(-1)"></tyl-button>
</mat-dialog-actions>
